import React, { Component } from 'react';

class Footer extends Component {
  render() {
    if (!this.props.data) return null;

    return (
      <footer>
        <div className="container">
          <div className="flex justify-center gap-6 mb-8" style={{ position: 'relative', zIndex: 99999 }}>
            {/* GitHub FIRST */}
            <a 
              href="https://github.com/Arrotech"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-14 h-14 rounded-full bg-white/10 border-2 border-white/30 text-white hover:bg-[#333] hover:border-[#333] transition-all duration-300 hover:-translate-y-2 hover:scale-110 hover:shadow-xl"
              style={{ cursor: 'pointer', position: 'relative', zIndex: 99999 }}
              aria-label="GitHub"
            >
              <i className="fa fa-github text-xl"></i>
            </a>
            {/* LinkedIn SECOND */}
            <a 
              href="https://www.linkedin.com/in/harun-gitundu-9a19ba155/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-14 h-14 rounded-full bg-white/10 border-2 border-white/30 text-white hover:bg-[#0077B5] hover:border-[#0077B5] transition-all duration-300 hover:-translate-y-2 hover:scale-110 hover:shadow-xl"
              style={{ cursor: 'pointer', position: 'relative', zIndex: 99999 }}
              aria-label="LinkedIn"
            >
              <i className="fa fa-linkedin text-xl"></i>
            </a>
          </div>

          <p>
            Designed & Built with <span role="img" aria-label="love">❤️</span> by Harun Gitundu
          </p>

          <p>&copy; {new Date().getFullYear()} Harun Gitundu. All rights reserved.</p>
        </div>

        <div id="go-top">
          <a
            className="smoothscroll"
            title="Back to Top"
            href="#home"
            aria-label="Back to top"
          >
            <i className="icon-up-open"></i>
          </a>
        </div>
      </footer>
    );
  }
}

export default Footer;
